import { useParams } from "react-router-dom";
import { useAuth } from "@/store/auth";
import type { UiRole } from "@/types";

export function roleLabel(role: UiRole | null | undefined): string {
  switch (role) {
    case "super_admin":
      return "Superuser";
    case "tenant_admin":
      return "Tenant Admin";
    case "tenant_writer":
      return "Tenant Writer";
    case "tenant_reader":
      return "Tenant Reader";
    default:
      return "Unknown";
  }
}

export function tenantBasePath(tenantId: string): string {
  return `/tenants/${encodeURIComponent(tenantId)}`;
}

export function useTenantWorkspace() {
  const params = useParams();
  const role = useAuth((s) => s.user?.role ?? null);
  const tenantScope = useAuth((s) => s.tenantScope);
  const tenantName = useAuth((s) => s.tenantName);
  const isSuper = role === "super_admin";
  const tenantId = isSuper ? params.tenantId : tenantScope && tenantScope !== "*" ? tenantScope : null;

  return {
    role,
    isSuper,
    tenantId,
    tenantName,
    hasTenant: Boolean(tenantId),
    basePath: tenantId ? tenantBasePath(tenantId) : null,
  };
}

export function canManageTenant(role: UiRole | null | undefined): boolean {
  return role === "super_admin" || role === "tenant_admin";
}

export function canWriteTenant(role: UiRole | null | undefined): boolean {
  return role === "super_admin" || role === "tenant_admin" || role === "tenant_writer";
}
